// Frontend Configuration
export const FRONTEND_BASE_URL = import.meta.env.VITE_FRONTEND_URL || window.location.origin;
export const APP_NAME = import.meta.env.VITE_APP_NAME || 'NexaPos';

// Helper functions for navigation
export const navigateToLogin = () => {
  window.location.href = `${FRONTEND_BASE_URL}/login`;
};

export const navigateToHome = () => {
  window.location.href = `${FRONTEND_BASE_URL}/`;
};

export const navigateToDashboard = () => {
  window.location.href = `${FRONTEND_BASE_URL}/dashboard`;
};

export const getCurrentPath = () => {
  return window.location.pathname;
};

export const isOnHomepage = () => {
  return getCurrentPath() === '/';
};

export const isOnLoginPage = () => {
  return getCurrentPath() === '/login';
};
